import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, ParamMap } from "@angular/router";
import { userDetails } from "src/app/models/user.model";
import { MLSListingService } from "src/services/mls-listings.service";
import { UserDetailService } from "src/services/user-details.service";

@Component({
    selector: "app-agent-profile-page",
    templateUrl: "./agent-profile-page.component.html",
    styleUrls: ["./agent-profile-page.component.css"],
})
export class AgentProfilePageComponent implements OnInit {
    urlName = "";
    userDetail: any;
    listings: any;
    constructor(
        public route: ActivatedRoute,
        private userService: UserDetailService,
        private mlsService: MLSListingService
    ) {}

    ngOnInit() {
        this.userDetail = this.userService.getUserDetails();
        //console.log(this.userDetail);

        if (!this.userDetail) {
            this.route.paramMap.subscribe((params: ParamMap) => {
                if (params.has("team-member-name")) {
                    this.urlName = params.get("team-member-name");
                    // console.log(this.urlName);
                                                    }
            });

            //this.urlName = this.splitPascalCase(this.urlName);
            //console.log(this.urlName);

            this.userService
                .getProfileDetails(this.urlName)
                .subscribe((res) => {
                    this.userDetail = (res as any).userDetails;
                    // console.log(this.userDetail);
                    // if(this.userDetail.bio1 == "Bio Line 1") {
                    //   this.userDetail.bio1 = this.userDetail.full_name + " is a Real Estate Agent with Stride Real Estate";
                    //   this.userDetail.bio2 = "";
                    //   this.userDetail.bio3 = "";
                    // }
                    //console.log(this.userDetail.agentMLS_ID);
                });

            
        }

        
        
    }

    posts_open = true;
    reviews_open = false;
    settings_open = false;
    title = "user-profile";

    opentabPosts() {
        this.posts_open = true;
        this.reviews_open = false;
        this.settings_open = false;
    }

    opentabReviews() {
        this.posts_open = false;
        this.reviews_open = true;
        this.settings_open = false;
    }

    splitPascalCase(word) {
        const wordRe = /($[a-z])|[A-Z][^A-Z]+/g;
        const output = word.match(wordRe).join(" ");
        return output;
    }

    getImageUrl(imageUrl) {
        if (imageUrl === "empty") {
            return "../../../assets/images/empty-profile.png";
        } else {
            return imageUrl;
        }
    }

    getBio1(name, bio1) {
        if (bio1 == "Bio Line 1") {
            const bio =
                name + " is a Real Estate Agent with Stride Real Estate";
            return bio;
        } else {
            return bio1;
        }
    }

    getBio2(bio2) {
        if (bio2 == "Bio Line 2") {
            const bio = "";
            return bio;
        } else {
            return bio2;
        }
    }

    getBio3(bio3) {
        if (bio3 == "Bio Line 3") {
            const bio = "";
            return bio;
        } else {
            return bio3;
        }
    }

    

    
    
}
